import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import React from 'react';

interface IFilterOption {
  label: string;
  value: string;
  hide?: boolean;
}

interface IFilterCategory {
  title: string;
  defaultItem?: string;
  options: IFilterOption[];
}

interface INavSectionProps {
  settings: any;
  onCheckedListChange?: (checkedList: CheckboxValueType[]) => void;
}

const NavSection: React.FunctionComponent<INavSectionProps> = ({
  settings,
  onCheckedListChange,
}) => {
  const filterCategories: IFilterCategory[] = (
    settings?.filterCategories || []
  ).map((category: IFilterCategory) => ({
    ...category,
    options: (category.options || []).filter((itm) => !itm.hide),
  }));

  const options = filterCategories.flatMap((category) => category.options);

  const [checkedList, setCheckedList] = React.useState<CheckboxValueType[]>(
    options.map((option) => option.value)
  );

  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(true);

  React.useEffect(() => {
    if (onCheckedListChange) {
      onCheckedListChange(checkedList);
    }
  }, [checkedList, onCheckedListChange]);

  const onChange = (list: CheckboxValueType[]) => {
    console.log('checkedList:', list);
    setCheckedList(list);
    setIndeterminate(Boolean(list.length) && list.length < options.length);
    setCheckAll(list.length === options.length);
  };

  const onCheckAllChange = (e: any) => {
    const allValues = options.map((option) => option.value);
    setCheckedList(e.target.checked ? allValues : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const onCategoryChange = (
    categoryOptions: IFilterOption[],
    list: CheckboxValueType[]
  ) => {
    const categoryValues = categoryOptions.map((option) => option.value);
    const rest = checkedList.filter(
      (value) => !categoryValues.includes(String(value))
    );
    onChange([...rest, ...list]);
  };

  return (
    <div className="course-section-body-left">
      <div className="filter">{settings?.navTitle}</div>
      <Checkbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        {settings?.navSelectAll}
      </Checkbox>
      <div className="sub-filter">
        {filterCategories.map((category) => {
          const categoryValues = category.options.map((option) => option.value);
          const categoryChecked = checkedList.filter((value) =>
            categoryValues.includes(String(value))
          );

          return (
            <div key={category.title} className="filter-category">
              <div className="filter-item">{category.title}</div>
              {category.defaultItem && (
                <div className="ant-checkbox-wrapper ant-checkbox-wrapper-checked default-item">
                  <span className="ant-checkbox ant-checkbox-checked">
                    <span className="ant-checkbox-inner" />
                  </span>
                  <span>{category.defaultItem}</span>
                </div>
              )}
              <Checkbox.Group
                options={category.options}
                value={categoryChecked}
                onChange={(list) => onCategoryChange(category.options, list)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NavSection;
